// --------------------------------------------------------------
// Created On: 2024-04-01
// Author: Dimitra Weinstein
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { Fragment, useRef } from "react";
import { Button } from "react-bootstrap";
import { useReactToPrint } from "react-to-print";
import styles from "./PrintBom.module.scss";

// Renders flat list of parts from a bom.
export default function PrintBom(props: Props): Component {
  const contentToPrint = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({
    contentRef: contentToPrint,
    documentTitle: props.bomNumber,
  });

  return (
    <Fragment>
      <div className={styles.printContent} ref={contentToPrint}>
        <h5 className={styles.pdfTitle}>{props.bomNumber}</h5>
        <table className={`${styles.table} table mb-0 pb-0`}>
          <thead>
            <tr>
              <th>Part Number</th>
              <th>Description</th>
              <th>Quantity</th>
            </tr>
          </thead>
          <tbody>
            {props.parts.map((part, index) => (
              <tr key={index}>
                <td>{part.partNumber}</td>
                <td>{part.description}</td>
                <td>
                  {part.buildQuantity}&nbsp;{part.units}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Button
        type="button"
        data-test="print-bom-btn"
        className="btn btn-primary btn-md w-100 py-3 my-0 mb-2 mb-xl-0"
        onClick={handlePrint}
      >
        <span className="d-none d-md-inline">Print BOM</span>
        <i className="d-inline d-md-none fa fa-2x fa-print" />
      </Button>
    </Fragment>
  );
}

interface Props {
  bomNumber: string;
  parts: Part[];
}

interface Part {
  partNumber: string;
  description: string;
  buildQuantity: string;
  units: string;
}
